var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUiInfoCircleSolidLtr = function SvgUiInfoCircleSolidLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 8c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42m.325 31.75c-1.424 0-2.583 1.064-2.624 2.392v30.844c0 1.361 1.175 2.464 2.624 2.464 1.424 0 2.583-1.064 2.624-2.391l.001-.073V42.214c0-1.36-1.175-2.464-2.625-2.464m-.1-15.75a4.725 4.725 0 1 0 0 9.45 4.725 4.725 0 0 0 0-9.45"
  })));
};
export default SvgUiInfoCircleSolidLtr;